import React, { Fragment } from "react";
import i18next from "i18next";
import { withTranslation, Trans } from "react-i18next";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Checkbox from "@material-ui/core/Checkbox";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import FormLabel from "@material-ui/core/FormLabel";
import Select from "@material-ui/core/Select";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import classnames from "classnames";
import Services from "../../api/api";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { setLangID } from "../../redux/actions/appActions";

const useStyles = (theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    width: "-webkit-fill-available",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    backgroundColor: "rgba(0, 0, 0, .02)",
  },
});


class DependentQuestionnaire extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      questionlist: [],
      dependantquestionlist: [],
      dependantquestionArr: [],
      isLoading: false,
      showSlider: true,
      temp: false,
      animCssClasses: "animate__animated animate__zoomIn animate__faster",
      value: this.props.question.response != undefined ? this.props.question.response.value[0] : ''
    };
  }

  componentDidMount() { }

  static getDerivedStateFromProps(nextProps) {
    return {
      animCssClasses: nextProps.animCssClasses,
      showSlider: nextProps.showSlider,
    };
  }

  renderQuestion() {
    const { classes } = this.props;
    var element = this.props.question;
    var quslist = [];
    return (
      <>
        <Grid
          key={element.id}
          container
          spacing={0}
          className="gridcontainer chatuserlistdiv"
        >
          <Grid item xs={2} className="zero">
            <p className="zero color-green text-center forumicon">
              <LockOpenIcon />
            </p>
          </Grid>
          <Grid item xs={10} className="zero">
            <p className="zero color-green chatusername">{element.question}</p>
          </Grid>
        </Grid>
        <div className={classes.root}>
          <div className="reportform">
            <FormControl component="fieldset" className={classes.formControl}>
              <FormGroup>{this.getQuestionType(element)}</FormGroup>
            </FormControl>
          </div>
        </div>
      </>
    );
  }

  getQuestionType(element) {
    switch (element.type.toLowerCase()) {
      case "text":
        return this.getTextType(element);
      case "date":
        return this.getDateType(element);
      case "radio":
        return this.getRadioType(element);
      case "checkbox":
        return this.getCheckboxType(element);
    }
  }


  getTextType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"dependant-" + element.id}
        value={this.state.value}
        onChange={this.handleChangeText}
        control={
          <TextField name={'dependant-' + this.props.parentId + '-' + element.id} />
        }
      />
    );
  }

  getDateType(element) {
    return (
      <FormControlLabel
        className="getinvolvedtextboxholder"
        name={"dependant-" + element.id}
        control={
          <TextField type="date" name={'dependant-' + this.props.parentId + '-' + element.id} />
        }
      />
    );
  }

  getRadioType(element) {
    var radiobuttons = [];
    let options = Object.keys(element.optionMap);

    options.map((o, i) => {
      radiobuttons.push(
        <FormControlLabel
          className="formlabel"
          key={i}
          id={i}
          name={"dependant-" + element.id}
          value={o}
          control={<Radio name={"dependant-" + this.props.parentId + '-' + element.id} />}
          label={element.optionMap[o]}
          onChange={this.handleChangeRadio}
        />
      );
    });

    return <RadioGroup name={element.name} value={this.state.value}>{radiobuttons}</RadioGroup>;
  }

  handleChangeRadio = (event, isInputChecked) => {
    var values = parseInt(event.target.value)
    this.setState({ value: event.target.value })
  }

  handleChangeText = (event, isInputChecked) => {
    var values = event.target.value
    this.setState({ value: values })
  }

  getCheckboxType(element) {
    var checkbuttons = [];
    let keys = Object.keys(element.optionMap);

    // Object.entries(element.optionMap).forEach(entry => {
    //   const [key, value] = entry; 
    //   checkbuttons.push(
    //     <FormControlLabel
    //       key={key}
    //       id={key}
    //       name={"check-" + element.id}
    //       value={key}
    //       control={<Checkbox name={"checkbox-" + element.id} />}
    //       label={value}
    //       onClick={(evt) => this.inputChangevent(element.id, evt)}
    //     />
    //   );
    // })

    keys.map((o, i) => {
      checkbuttons.push(
        // <FormControlLabel name={element.name} id={i} value={o} control={<Checkbox />} label={o} />
        <FormControlLabel
          key={i}
          name={"dependant-" + element.id}
          value={o}
          control={<Checkbox name={"dependant-" + this.props.parentId + '-' + element.id} />}
          label={element.optionMap[o]}
        />
      );
    });
    return <FormGroup>{checkbuttons}</FormGroup>;
  }

  render() {
    const { classes } = this.props;
    const { t } = this.props;
    if (this.props.question) {
      return <>{this.renderQuestion()}</>;
    }
    return null;
  }
}

export default withStyles(useStyles)(withTranslation()(DependentQuestionnaire));
